import script from "./MisActivos.vue?vue&type=script&setup=true&lang=js"
export * from "./MisActivos.vue?vue&type=script&setup=true&lang=js"

import "./MisActivos.vue?vue&type=style&index=0&id=71650422&scoped=true&lang=css"
import "./MisActivos.vue?vue&type=style&index=1&id=71650422&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71650422"]])

export default __exports__